'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.primary_dropdown_menu {\n  list-style-type: none;\n  display: none;\n  min-width: 0;\n  width: 100%;\n  position: relative;\n  left: auto;\n  top: auto;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  margin: 0;\n  padding: 0;\n  background-color: #ffffff;\n}\n@media (min-width: 1200px) {\n  .primary_dropdown_menu {\n    min-width: 224px;\n    width: auto;\n    padding: 0;\n    position: absolute;\n    left: 0;\n    top: 100%;\n    box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.16);\n  }\n}\n.primary_dropdown_menu.show {\n  display: block;\n}\n\n.secondary_dropdown_menu {\n  list-style-type: none;\n  display: none;\n  min-width: 0;\n  width: 100%;\n  position: relative;\n  left: auto;\n  top: auto;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  margin: 0;\n  padding: 0;\n  background-color: #ffffff;\n  box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.16);\n}\n@media (min-width: 1200px) {\n  .secondary_dropdown_menu {\n    min-width: 224px;\n    width: auto;\n    padding: 0;\n    position: absolute;\n    left: 100%;\n    top: 0;\n    box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.16);\n  }\n}\n.secondary_dropdown_menu.show {\n  display: block;\n}");
//# sourceMappingURL=DropdownNav.scss.js.map
